module.exports = __webpack_public_path__ + "images/ba8cc7e99637ab29bb3a707cc33327ac.png";